/* Parbiart Mix — a termékoldali saját szekciók viselkedése.
   1. Képek (sections/pb-mozaik.liquid): a csempe saját, egyszerű képnézegetőt nyit (<dialog>):
      a kép a képernyőhöz méretezve, lapozás a termék összes képén (nyilak, ←/→), Esc és a
      fátyolra kattintás bezár. A gyári nézegető teljes szélességre nagyított — azt nem használjuk.
   2. Családlapozó (sections/pb-csalad.liquid): nyilak, ←/→ billentyű, a szélen letiltott nyíl.
   Minden init ismételhető (a témaszerkesztő újratölti a szekciót). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. képek → saját képnézegető ---- */
  function gomb(osztaly, felirat, jel) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pb-lightbox__btn pb-lightbox__btn--' + osztaly;
    b.setAttribute('aria-label', felirat);
    b.textContent = jel;
    return b;
  }
  function initMozaik(root) {
    if (!root || root.dataset.pbInit) return;
    root.dataset.pbInit = '1';
    var kepek = [];
    try { kepek = JSON.parse(root.querySelector('[data-pb-kepek]').textContent); } catch (err) { kepek = []; }
    if (!kepek.length || typeof HTMLDialogElement === 'undefined') return; // nézegető nélkül a csempe egyszerűen nem nyit semmit

    var dlg = document.createElement('dialog');
    dlg.className = 'pb-lightbox';
    var belso = document.createElement('div');
    belso.className = 'pb-lightbox__in';
    var img = document.createElement('img');
    img.className = 'pb-lightbox__img';
    var szam = document.createElement('span');
    szam.className = 'pb-lightbox__szam';
    var x = gomb('x', root.dataset.bezar || 'Bezárás', '×');
    var elozo = gomb('e', root.dataset.elozo || 'Előző kép', '←');
    var kov = gomb('k', root.dataset.kovetkezo || 'Következő kép', '→');
    belso.appendChild(img);
    dlg.appendChild(belso);
    dlg.appendChild(x);
    if (kepek.length > 1) { dlg.appendChild(elozo); dlg.appendChild(kov); dlg.appendChild(szam); }
    document.body.appendChild(dlg);

    var i = 0, nyito = null;
    // Mekkora lesz a kép a képernyőn? (ugyanaz a számítás, mint a CSS-ben) — ehhez kérünk méretet.
    function szelesseg(k) {
      var p = Math.min(Math.max(16, window.innerWidth * 0.04), 56);
      return Math.round(Math.min(window.innerWidth - 2 * p, 1100, (window.innerHeight - 2 * p) * (k.ar || 1)));
    }
    function forras(k) {
      var kell = szelesseg(k) * Math.min(window.devicePixelRatio || 1, 2);
      return kell <= 800 ? k.s800 : kell <= 1200 ? k.s1200 : k.s1800;
    }
    // Előtöltés: a böngésző gyorsítótárába kerül, a váltás utána azonnali.
    var tar = {};
    function elotolt(n) {
      var k = kepek[(n + kepek.length) % kepek.length];
      var u = forras(k);
      if (!tar[u]) { tar[u] = new Image(); tar[u].decoding = 'async'; tar[u].src = u; }
      return tar[u];
    }
    function mutat(n) {
      i = (n + kepek.length) % kepek.length;
      var k = kepek[i], u = forras(k), nagy = elotolt(i), ez = i;
      img.style.setProperty('--ar', k.ar || 1);
      img.alt = k.alt || '';
      szam.textContent = (i + 1) + ' / ' + kepek.length;
      if (nagy.complete && nagy.naturalWidth) {
        img.src = u;
      } else {
        // amíg a nagy jön, az a kép látszik, amit a csempe MÁR betöltött (ez biztosan a gyorsítótárban van);
        // a hatodik képtől nincs csempe — ott a kis változatot kérjük le
        var cs = root.querySelector('[data-pb-kep="' + i + '"] img');
        img.src = (cs && cs.complete && cs.currentSrc) || k.kicsi;
        nagy.addEventListener('load', function () { if (ez === i && dlg.open) img.src = u; }, { once: true });
      }
      if (kepek.length > 1) { elotolt(i + 1); elotolt(i - 1); }
    }
    // Amint az egér a képek fölé ér (vagy érintés / fókusz), a kitett képek nagy változata már töltődik.
    var felkeszult = false;
    function felkeszul() {
      if (felkeszult) return;
      felkeszult = true;
      for (var n = 0; n < Math.min(kepek.length, 5); n++) elotolt(n);
    }
    root.addEventListener('pointerenter', felkeszul, { once: true });
    root.addEventListener('touchstart', felkeszul, { once: true, passive: true });
    root.addEventListener('focusin', felkeszul, { once: true });
    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-pb-kep]');
      if (!tile) return;
      nyito = tile;
      mutat(Number(tile.getAttribute('data-pb-kep')) || 0);
      dlg.showModal();
    });
    x.addEventListener('click', function () { dlg.close(); });
    elozo.addEventListener('click', function () { mutat(i - 1); });
    kov.addEventListener('click', function () { mutat(i + 1); });
    // a kép melletti üres részre (a fátyolra) kattintás bezár
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === belso) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (kepek.length < 2) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); mutat(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); mutat(i - 1); }
    });
    dlg.addEventListener('close', function () { img.removeAttribute('src'); if (nyito) nyito.focus(); });
  }

  /* ---- 2. családlapozó ---- */
  function initRail(wrap) {
    if (!wrap || wrap.dataset.pbInit) return;
    var rail = wrap.querySelector('.pb-rail');
    if (!rail) return;
    wrap.dataset.pbInit = '1';
    var btns = Array.prototype.slice.call(wrap.querySelectorAll('.pb-rail-btn'));

    function upd() {
      // 8 px tűrés: a scroll-snap a sor paddingje miatt kiinduláskor 4 px-re áll (mérve)
      var max = rail.scrollWidth - rail.clientWidth - 8;
      btns.forEach(function (b) {
        b.disabled = b.dataset.rail < 0 ? rail.scrollLeft <= 8 : rail.scrollLeft >= max;
      });
    }
    function step(dir) {
      rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { step(Number(b.dataset.rail)); });
    });
    rail.addEventListener('keydown', function (e) {
      if (e.target !== rail) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pb-mozaik]'), initMozaik);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pb-rail-wrap]'), initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
